import { styled } from '@mui/material/styles';

export const MainContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: stretch;
`;
